import Vue from 'vue';
import isURL from 'validator/lib/isURL';
import { ValidationProvider, ValidationObserver, localize, extend } from 'vee-validate';
import { email, required, required_if as requireIf } from 'vee-validate/dist/rules';
import en from 'vee-validate/dist/locale/en.json';
import th from 'vee-validate/dist/locale/th.json';

extend('required', required);
extend('required_if', requireIf);
extend('email', email);
extend('url', {
  validate: (value) => isURL(value),
});
extend('currency', {
  validate: (value) => /^\d+\.?\d*$/.test(value)
});
extend('currency_if', {
  validate: (value, { target, values }) => {
    let isRequired;

    if (values && values.length) {
      if (!Array.isArray(values) && typeof values === 'string') {
        // eslint-disable-next-line no-param-reassign
        values = [values];
      }

      isRequired = values.some((val) => val === String(target).trim());
    } else {
      isRequired = ![false, null, undefined, ''].includes(target);
    }

    if (!isRequired) {
      return {
        valid: true,
        required: isRequired,
      };
    }

    return {
      valid: /^\d+\.?\d*$/.test(value),
      required: isRequired,
    };
  },
  params: [{
    name: 'target',
    isTarget: true,
  }, {
    name: 'values'
  }]
});

localize({
  en: {
    ...en,
    messages: {
      ...en.messages,
      url: 'The {_field_} field is not a valid value',
      currency: 'The {_field_} field is not a decimal',
    },
  },
  th: {
    ...th,
    messages: {
      ...th.messages,
      url: '{_field_} มีรูปแบบไม่ถูกต้อง',
      currency: '{_field_} ต้องระบุเป็นตัวเลข',
    },
  },
});

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
